import { StoreConfigJsonStoreView } from '@emico-utils/storeview-manager'
import React, { createContext, ReactNode } from 'react'

export const ActiveStoreViewContext = createContext<
  StoreConfigJsonStoreView | undefined
>(undefined)

interface ActiveStoreViewProviderProps {
  children: ReactNode
  storeView: StoreConfigJsonStoreView
}

export const ActiveStoreViewProvider = ({
  children,
  storeView,
}: ActiveStoreViewProviderProps) => (
  <ActiveStoreViewContext.Provider value={storeView}>
    {children}
  </ActiveStoreViewContext.Provider>
)
